<template>
    <div class="col-md-5 pb-col">
        <div class="card bdr-15 card-frame-link">
            <button type="button" class="btn btn-new btn-prv" @click.prevent="reloadFrame()">Update Preview</button>

            <div class="phone-block">
               <iframe id="iframeevent" :src="detail_event | bioLink"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            detail_event:{
                type: Object,
                required: true,
            },
        },
        filters: {
            bioLink: function(value) {
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:3000/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                return frameURL + value.id + '/' + value.slug
            },
        },
        methods:{
            reloadFrame:function(){
                document.getElementById('iframeevent').src += '';
            }
        }
    }
</script>
